import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bzzx",
  "use": "icon-bzzx-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bzzx\">\n<g id=\"icon-bzzx_bzzx\" stroke=\"currentColor\">\n<g id=\"icon-bzzx_bzzx/white\">\n<path d=\"M10.5 7.5H8.5V8.5H10.5V9.5H8.5V12H7.5V9.5H5.5V8.5H7.5V7.5H5.5V6.5H6.95969L5.60956 4.81235L6.39043 4.18765L8 6.19961L9.60956 4.18765L10.3904 4.81235L9.04031 6.5H10.5V7.5Z\" fill=\"#282C33\" />\n<path d=\"M15 8C15 4.13401 11.866 1 8 1C4.13401 0.999998 1 4.134 1 8C0.999998 11.866 4.134 15 8 15C11.866 15 15 11.866 15 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bzzx.svg
// module id = Axgf
// module chunks = 140